import { cairo, CallData } from 'starknet';
export function buildApproveTx(params) {
    return {
        contractAddress: params.token,
        entrypoint: 'approve',
        calldata: CallData.compile([params.spender, cairo.uint256(params.amount)]),
    };
}
